import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';

const SitemapPage = () => {
  const { t } = useTranslation();

  const sections = [
    {
      title: t('sitemap_page.sections.company'),
      links: [
        { to: '/', label: t('sitemap_page.links.home') },
        { to: '/crm', label: t('sitemap_page.links.bitrix24') },
        { to: '/apps', label: t('sitemap_page.links.apps') },
        { to: '/blog', label: t('sitemap_page.links.blog') },
      ],
    },
    {
      title: t('sitemap_page.sections.solutions'),
      links: [
        { to: '/whatsapp', label: t('sitemap_page.links.whatsapp') },
        { to: '/telefonia', label: t('sitemap_page.links.telefonia') },
        { to: '/dispersion-tecnologica', label: t('sitemap_page.links.dispersion') },
        { to: '/on-premise-vs-on-cloud', label: t('sitemap_page.links.cloud') },
        { to: '/reclutamiento-de-personal', label: t('sitemap_page.links.recruitment') },
        { to: '/clinicas', label: t('sitemap_page.links.clinics') },
      ],
    },
    {
      title: t('sitemap_page.sections.products'),
      links: [
        { to: '/nextshot', label: t('sitemap_page.links.nextshot') },
        { to: '/punku24', label: t('sitemap_page.links.punku24') },
      ],
    },
    {
      title: t('sitemap_page.sections.resources'),
      links: [
        { to: '/renacimiento', label: t('sitemap_page.links.renacimiento') },
        { to: '/inicia-con-bitrix24', label: t('sitemap_page.links.startBitrix24') },
        { to: '/guia-de-integracion', label: t('sitemap_page.links.integrationGuide') },
        { to: '/inteligencia-artificial-local', label: t('sitemap_page.links.localAi') },
      ],
    },
    {
      title: t('sitemap_page.sections.legal'),
      links: [
        { to: '/privacidad', label: t('sitemap_page.links.privacy') },
        { to: '/seguridad', label: t('sitemap_page.links.security') },
        { to: '/calidad', label: t('sitemap_page.links.quality') },
        { to: '/nextshot/privacy', label: t('sitemap_page.links.nextshotPrivacy') },
      ],
    },
  ];

  return (
    <div className="bg-white min-h-screen">
      <PageHeader hideCTA />

      <main className="pt-24">
        <section className="max-w-6xl mx-auto px-4 sm:px-6 py-16 md:py-24">
          <div className="max-w-3xl">
            <div className="inline-flex items-center rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.25em] text-gray-500">
              {t('sitemap_page.badge')}
            </div>
            <h1 className="mt-6 text-4xl md:text-5xl font-black tracking-tight text-[#141414]">
              {t('sitemap_page.title')}
            </h1>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              {t('sitemap_page.description')}
            </p>
          </div>

          <div className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {sections.map((section) => (
              <section
                key={section.title}
                className="rounded-3xl border border-gray-200 bg-white p-6 shadow-sm"
              >
                <h2 className="text-lg font-bold text-[#141414]">{section.title}</h2>
                <ul className="mt-4 space-y-3">
                  {section.links.map((link) => (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className="text-gray-600 hover:text-[#141414] transition"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default SitemapPage;
